import { render, staticRenderFns } from "./ViewEmployeeCustomDocumentStatus.vue?vue&type=template&id=364d5bc7&scoped=true"
import script from "./ViewEmployeeCustomDocumentStatus.vue?vue&type=script&lang=js"
export * from "./ViewEmployeeCustomDocumentStatus.vue?vue&type=script&lang=js"
import style0 from "./ViewEmployeeCustomDocumentStatus.vue?vue&type=style&index=0&id=364d5bc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d5bc7",
  null
  
)

export default component.exports